import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponsePagination} from '../../core/QueryResponseProvider'
import {DeletedTransactions} from '../../core/_models'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<DeletedTransactions>>
}
const DeletedTransactionsCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()
  const pagination = useQueryResponsePagination()

  const isSelectedForSorting = useMemo(() => {
    return state.sort && state.sort === id
  }, [state, id])
  const order: 'asc' | 'desc' | undefined = useMemo(() => state.order, [state])

  // const sortColumn = () => {
  //   // avoid sorting for these columns
  //   if (id === 'actions' || id === 'selection') {
  //     return
  //   }

  //   if (!isSelectedForSorting) {
  //     // enable sort asc
  //     updateState({sort: id, order: 'asc', page: pagination.page, perPage: state.perPage})
  //     return
  //   }

  //   if (isSelectedForSorting && order !== undefined) {
  //     if (order === 'asc') {
  //       // enable sort desc
  //       updateState({sort: id, order: 'desc', page: pagination.page, perPage: state.perPage})
  //       return
  //     }

  //     // disable sort
  //     updateState({
  //       sort: undefined,
  //       order: undefined,
  //       page: pagination.page,
  //       perPage: state.perPage,
  //     })
  //   }
  // }
  const sortColumn = () => {
    // avoid sorting for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }
  
    if (!isSelectedForSorting || order === 'desc') {
      // default to asc if not sorted or currently desc
      updateState({sort: id, order: 'asc', page: pagination.page, perPage: state.perPage})
    } else if (order === 'asc') {
      // toggle to desc
      updateState({sort: id, order: 'desc', page: pagination.page, perPage: state.perPage})
    }
  }
  

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        isSelectedForSorting && order !== undefined && `table-sort-${order}`
      )}
      style={{cursor: 'pointer'}}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {DeletedTransactionsCustomHeader}
